import { PAGE_MAX_WIDTH } from '../variables';

export default function iframesFunctionality() {
  setIframeSize();
}

function setIframeSize() {
  if ($('iframe').length) {
    const allVideos = $('iframe');
    const fluidEl = $('body');
    allVideos.each(function() {
      $(this)
        .data('aspectRatio', this.height / this.width)
        .removeAttr('height')
        .removeAttr('width');
    });

    $(window).resize(function() {
      let newWidth = fluidEl.width();
      allVideos.each(function() {
        const el = $(this);
        if (newWidth >= PAGE_MAX_WIDTH) {
          newWidth = PAGE_MAX_WIDTH;
        }
        el
          .width(newWidth)
          .height(newWidth * el.data('aspectRatio'));
      });
    }).resize();
  }
}
